export const coinNetworkReducer = (state = {}, action) => {
  switch (action.type) {
    case "SET_NETWORK_INFO":
      return action.payload;
    case "CLEAR_NETWORK_INFO":
      return action.payload;
    default:
      return state;
  }
};
